import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface ArticleActionsProps {
  articleId: string;
}

const shareIcons = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-share-forward-line", label: "转发" },
  { icon: "ri-link", label: "复制链接" },
];

export default function ArticleActions({ articleId }: ArticleActionsProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [notice, setNotice] = useState("");
  const saved = isFavorite(articleId);

  const flash = (message: string) => {
    setNotice(message);
    if (typeof window !== "undefined") {
      window.setTimeout(() => setNotice(""), 2200);
    }
  };

  const handleFavorite = () => {
    const nowSaved = toggleFavorite(articleId);
    flash(nowSaved ? "已加入收藏，收藏记录保存在本地浏览器" : "已取消收藏");
  };

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3">
      <div className="flex items-center gap-2">
        <span className="text-xs text-foreground-500">分享：</span>
        {shareIcons.map((item) => (
          <button
            key={item.label}
            type="button"
            onClick={() => flash(`“${item.label}”为演示效果，暂未接入第三方分享服务`)}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
            aria-label={`分享到${item.label}`}
            title={`分享到${item.label}（演示）`}
          >
            <i className={`${item.icon} text-lg`} />
          </button>
        ))}
      </div>

      <button
        type="button"
        onClick={handleFavorite}
        className={`flex items-center gap-2 whitespace-nowrap rounded-md px-4 py-2 text-sm font-label transition-colors cursor-pointer ${
          saved
            ? "bg-accent-500 text-accent-950 hover:bg-accent-400"
            : "bg-primary-500 text-background-50 hover:bg-primary-600"
        }`}
      >
        <i className={saved ? "ri-bookmark-fill text-lg" : "ri-bookmark-line text-lg"} />
        {saved ? "已收藏" : "收藏"}
      </button>

      {notice && (
        <p className="w-full text-xs text-accent-700" role="status">
          {notice}
        </p>
      )}
    </div>
  );
}